// Temporarily aggregate tab components here until GameUI is migrated to SFC
import AlchemyTab from "./alchemy/AlchemyTab";
import AntimatterDimensionsTab from "./antimatter-dimensions/AntimatterDimensionsTab";
import AutobuyersTab from "./autobuyers/AutobuyersTab";
import AutomatorTab from "./automator/AutomatorTab";
import BlackHoleTab from "./black-hole/BlackHoleTab";
import BreakInfinityTab from "./break-infinity/BreakInfinityTab";
import CelestialNavigationTab from "./celestial-navigation/CelestialNavigationTab";
import ChallengeRecordsTab from "./challenge-records/ChallengeRecordsTab";
import EffarigTab from "./celestial-effarig/EffarigTab";
import EnslavedTab from "./celestial-enslaved/EnslavedTab";
import EternityChallengesTab from "./eternity-challenges/EternityChallengesTab";
import EternityMilestonesTab from "./eternity-milestones/EternityMilestonesTab";
import EternityUpgradesTab from "./eternity-upgrades/EternityUpgradesTab";
import GlyphSetRecordsTab from "./glyph-set-records/GlyphSetRecordsTab";
import GlyphsTab from "./glyphs/GlyphsTab";
import ImaginaryUpgradesTab from "./imaginary-upgrades/ImaginaryUpgradesTab";
import InfinityChallengesTab from "./infinity-challenges/InfinityChallengesTab";
import InfinityDimensionsTab from "./infinity-dimensions/InfinityDimensionsTab";
import InfinityUpgradesTab from "./infinity-upgrades/InfinityUpgradesTab";
import LaitelaTab from "./celestial-laitela/LaitelaTab";
import MultiplierBreakdownTab from "./statistics/MultiplierBreakdownTab";
import NormalAchievementsTab from "./normal-achievements/NormalAchievementsTab";
import NormalChallengesTab from "./normal-challenges/NormalChallengesTab";
import OptionsGameplayTab from "./options-gameplay/OptionsGameplayTab";
import OptionsSavingTab from "./options-saving/OptionsSavingTab";
import OptionsVisualTab from "./options-visual/OptionsVisualTab";
import PastPrestigeRunsTab from "./past-prestige-runs/PastPrestigeRunsTab";
import PelleTab from "./celestial-pelle/PelleTab";
import PerksTab from "./perks/PerksTab";
import PreviousSpeedrunTab from "./speedrun-milestones/PreviousSpeedrunTab";
import RaTab from "./celestial-ra/RaTab";
import RealityUpgradesTab from "./reality-upgrades/RealityUpgradesTab";
import ReplicantiTab from "./replicanti/ReplicantiTab";
import SecretAchievementTab from "./secret-achievements/SecretAchievementTab";
import ShopTab from "./shop/ShopTab";
import SpeedrunMilestonesTab from "./speedrun-milestones/SpeedrunMilestonesTab";
import StatisticsTab from "./statistics/StatisticsTab";
import TeresaTab from "./celestial-teresa/TeresaTab";
import TimeDilationTab from "./time-dilation/TimeDilationTab";
import TimeDimensionsTab from "./time-dimensions/TimeDimensionsTab";
import TimeStudiesTab from "./time-studies/TimeStudiesTab";
import VTab from "./celestial-v/VTab";

//Custom Tabs Start Here
import MendingUpgrades from "./mending/MendingUpgrades";
import MendingMilestones from "./mending/MendingMilestones";
import WarpReality from "./mending/WarpReality";
import KohlersRealm from "./mending/KohlersRealm";
import CorruptionTab from "./corruption/CorruptionChallengeTab";
import MultiversalDimensionsTab from "./multiversal-dimensions/MultiversalDimensionsTab";
import KohlerInfinityUpgrades from "./infinity-upgrades/KohlerInfinityUpgrades";
import MatterUpgrades from "./matter/MatterUpgrades";
import MatterDimensionsTab from "./matter/matter-dimensions/MatterDimensionsTab";


const TabComponents = {
  AntimatterDimensionsTab,
  InfinityDimensionsTab,
  TimeDimensionsTab,
  OptionsSavingTab,
  OptionsVisualTab,
  OptionsGameplayTab,
  StatisticsTab,
  ChallengeRecordsTab,
  PastPrestigeRunsTab,
  GlyphSetRecordsTab,
  SpeedrunMilestonesTab,
  PreviousSpeedrunTab,
  NormalAchievementsTab,
  SecretAchievementTab,
  TeresaTab,
  EffarigTab,
  EnslavedTab,
  VTab,
  RaTab,
  LaitelaTab,
  PelleTab,
  AutobuyersTab,
  AutomatorTab,
  NormalChallengesTab,
  InfinityChallengesTab,
  EternityChallengesTab,
  InfinityUpgradesTab,
  BreakInfinityTab,
  ReplicantiTab,
  TimeStudiesTab,
  EternityUpgradesTab,
  EternityMilestonesTab,
  TimeDilationTab,
  GlyphsTab,
  RealityUpgradesTab,
  ImaginaryUpgradesTab,
  PerksTab,
  BlackHoleTab,
  AlchemyTab,
  CelestialNavigationTab,
  ShopTab,
  MultiplierBreakdownTab,
  MendingUpgrades,
  MendingMilestones,
  WarpReality,
  CorruptionTab,
  KohlersRealm,
  MultiversalDimensionsTab,
  KohlerInfinityUpgrades,
  MatterUpgrades,
  MatterDimensionsTab
};

export default TabComponents;
